/**
 * A second, quieter arrangement of the same tiles for the editorial pick.
 *
 * The hero fans them out on a table; here three stand in a shallow stack, like
 * a game box propped on a shelf. Same pieces, different composition, so the
 * two sections do not read as the same picture twice.
 */

import type { CSSProperties } from "react";
import { MahjongTile } from "../../components/tiles";
import type { TileKind } from "@kikik/mahjong-core";

const STACK: readonly TileKind[] = ["BAM1", "DOT5", "DRAGON_GREEN"];

export interface TilePosterProps {
  label: string;
}

export function TilePoster({ label }: TilePosterProps) {
  return (
    <div className="poster" role="img" aria-label={label}>
      <span className="poster__field" aria-hidden="true" />
      {STACK.map((kind, index) => (
        <span key={kind} className="poster__tile" style={{ "--i": index } as CSSProperties}>
          <MahjongTile kind={kind} size="lg" />
        </span>
      ))}
    </div>
  );
}
